import { initializeAuth as initializeKeycloak } from "@spiriidk/auth";

const KEYCLOAK_REALM = "production";
const KEYCLOAK_CLIENT_ID = "techportal";

function initializeAuth(): ReturnType<typeof initializeKeycloak> {
  return initializeKeycloak(
    {
      url: import.meta.env.VITE_AUTH_SERVER_URL as string,
      realm: KEYCLOAK_REALM,
      clientId: KEYCLOAK_CLIENT_ID,
    },
    {
      onLoad: "check-sso",
      pkceMethod: "S256",
      checkLoginIframe: true,
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
    }
  );
}

export { initializeAuth };
